import { combineReducers } from '@reduxjs/toolkit'
import purchaseIntention from './purchase-intention.store'
import reservation from './reservation.store'
import phones from './phones.store'

export const rootReducer = combineReducers({
  purchaseIntention,
  reservation,
  phones,
})
